<template>
  <div class="container">
    <div class="left-container" :class="loggedIn ? 'logged-in' : 'logged-out'">
      <header>
        <input v-if="offer.default" type="radio" :id="offer.id" name="offerChoice" :value="choiceValue" class="choice" checked="checked"  @click="onOfferSelect($event)">
        <input v-else type="radio" :id="offer.id" name="offerChoice" :value="choiceValue" class="choice" @click="onOfferSelect($event)"/>
        <label :for="offer.id" v-if="offer.term === ''" v-html="offer.description"></label>
        <label :for="offer.id" v-else v-html="offer.term"></label>
      </header>
      <ul class="offer-texts">
        <li v-if="offer.offer_text1"><i class="fa fa-check fa-fw" aria-hidden="true"></i><span v-html="offer.offer_text1"></span></li>
        <li v-if="offer.offer_text2"><i class="fa fa-check fa-fw" aria-hidden="true"></i><span v-html="offer.offer_text2"></span></li>
        <li v-if="offer.offer_text3"><i class="fa fa-check fa-fw" aria-hidden="true"></i><span v-html="offer.offer_text3"></span></li>
        <li v-if="offer.offer_text4"><i class="fa fa-check fa-fw" aria-hidden="true"></i><span v-html="offer.offer_text4"></span></li>
        <li v-if="offer.offer_text5"><i class="fa fa-check fa-fw" aria-hidden="true"></i><span v-html="offer.offer_text5"></span></li>
      </ul>
    </div>
    <DynamicPriceInfo :term-length="offer.term" :offer-id="offer.id"/>
  </div>
</template>

<script>
import DynamicPriceInfo from './DynamicPriceInfo.vue'
import { mapActions, mapWritableState } from 'pinia/dist/pinia'
import useBundleStore from '@/store/bundle'
import {mapState} from "pinia"

export default {
  name: "BundleChoice",
  components: {
    DynamicPriceInfo
  },
  data () {
    return {
      loggedIn: this.bundleData.loggedIn ?? false
    }
  },
  mounted () {
    let productPrice = parseFloat(this.offer.product1_price)
    this.productPrice = productPrice
    this.setOffer(this.offer.id, { productPrice: productPrice })
  },
  computed: {
    ...mapWritableState(useBundleStore, ['productPrice', 'selectedOffer', 'creditsLoading']),
    ...mapState(useBundleStore, ['total', 'setSelectedOffer']),
    choiceValue () {
      return `${this.offer.product1}|${this.offer.product2}|${this.offer.name}|${this.offer.transaction_type}`
    }
  },
  created () {
    window.addEventListener('tax-calculated', this.handleTaxCalcEvent)
  },
  methods: {
    ...mapActions(useBundleStore, ['setOffer']),
    handleTaxCalcEvent (event) {
      let offerId = event.detail.offerId;
      if (this.total > 0 && offerId === this.selectedOffer) {
        this.commercejs.enableSubmitButton(['choice-selected'])
      } else {
        this.commercejs.disableSubmitButton("Order Unavailable", ['too-many-credits'])
      }
    },
    onOfferSelect (event) {
      const selectedId = event.target.id
      this.setSelectedOffer(selectedId)
      if (this.commercejs.hasTaxPreview()) {
        this.commercejs.updateTaxPreview(selectedId, true)
        return
      }
      if (!this.creditsLoading) {
        if (this.total > 0) {
          this.commercejs.enableSubmitButton(['choice-selected'])
        } else {
          this.commercejs.disableSubmitButton('Order Unavailable', ['too-many-credits'])
        }
      }
    }
  },
  props: {
    offer: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/variables";
.container {
  display: flex;
  background-color: #fff;
  border-radius: $border-radius;
  box-shadow: 0 0 1px rgb(255 255 255 / 50%);
}
.left-container {
  padding: 2rem 1rem;
  width: 60%;
  text-align: left;
}
.left-container.logged-out {
  width: 80%;
}
header {
    display: flex;
    align-items: center;
    height: 45px;
}
label {
  font-family: "Merriweather", "Times New Roman", serif;
  font-weight: bold;
  font-size: 1.4em !important;
  margin-top: 0 !important;
}
input[type=radio].choice {
  margin-right: 1rem;
  margin-bottom: 0;
  width: 3em;
  height: 3rem;
  accent-color: var(--tmf-blue);
}
ul.offer-texts {
  margin: 0 0 0 52px;
  list-style-type: none;
  text-indent: -24px;
  padding-left: 30px;
}
li {
  font-family: var(--default-font-stack);
  font-size: 1.1em;
  margin-bottom: 1rem;
  list-style-type: none;
  font-weight: 100;
}
.fa-check {
  color: #393;
  display: inline-block !important;
  width: 1.25em;
}
@media (max-width: $mobile-breakpoint) {
  .container {
    flex-direction: column;
  }
  .left-container {
    width: 100%;
  }
}
</style>
